// Copyright © 2015-2020 TrampleZone LLC All Rights Reserved

// Browser Module

// Open the specified url in the given target window.  Detect if running as
// a mobile app.  If so, use Cordova InAppBrowser support to open url within
// the context of the app and allow for quick return.  Otherwise, open the
// url in the system browser which is outside the app.  In this case, the
// user will need to manually return to the app.

// Expected Behavior when clicking on a Link:
//
// Desktop Browser:
//      New browser window or tab will be opened
//
// Mobile Browser:
//      New mobile browser tab will be opened
//
// Mobile Homescreen App:
//      IOS:
//          New mobile browser tab will be opened and given focus
//          Use task manager to return to app instance which will be restarted,
//          this is an unfortunate limitation in IOS
//      Android:
//          New mobile browser tab will be opened and given focus
//          Use task manager to return to app right where it left off
//
// Mobile Installed App:
//      IOS:
//          InApp Browser is opened with bottom toolbar, use back button to
//          return to the app.
//      Android:
//          InApp Browser is opened with top toolbar, use X button to return
//          to app.

// @param url website to open in the browser
// @param target container to open, e.g. _self, _blank, _system

define('Browser',['require','Utilities'],function (require) {
    'use strict';

    var // Require.js module dependencies
        Utilities = require('Utilities'),

        // Instance vars
        utilities;

    // Constructor
    function Browser (url, target) {

        // Dependent Resources
        utilities = new Utilities();

        // Instance variables
        this.url = url;
        this.target = target;
        this.windowRef = null;
        this.options = '';

        // Cordova InApp browser options
        if (utilities.isAndroid()) {
            this.options += 'location=yes';
        } else if (utilities.isIOS()) {
            this.options += 'location=no' +
            ',closebuttoncaption=\u25C4 Back to ' + utilities.getApplicationName() +
            ',transitionstyle=crossdissolve,' +
            ',toolbarposition=bottom';
        };

        // Show the browser
        this.show = function () {
            if (utilities.isMobile() && utilities.isMobileApp()) {
                // Use Cordova InAppBrowser to load url
                this.windowRef = window.open(this.url, this.target, this.options);
                this.windowRef.addEventListener('loaderror', function (event) {
                    utilities.showAlert('Sorry, unable to load page: <br><br>' +
                                        'Page: ' + event.url + '<br>' +
                                        'Error Code: ' + event.code + '<br>' +
                                        'Error Message: ' + event.message);
                    this.close();
                }.bind(this));
            } else if (utilities.isMobile() && !utilities.isStandalone()) {
                // Use the system browser to open the url (brute force workaround)
                var a = document.createElement('a');
                a.setAttribute('href', this.url);
                a.setAttribute('target', this.target);
                a.click();
            } else {
                // Use desktop browser to open url using standard APIs
                this.windowRef = window.open(this.url, this.target);
            }
        };

        // Add specified listener (on mobile)
        this.addEventListener = function (type, callback) {
            if (this.windowRef) {
                if (type === 'loadstart' || type === 'loadstop' ||
                    type === 'loaderror' || type === 'exit') {
                    this.windowRef.addEventListener(type, function (event) {
                        if (callback) {
                            callback(event);
                        }
                    });
                } else {
                    console.log('WARNING: Browser does not support event type - ' + type);
                }
            }
        }.bind(this);

        // Add specified listener (on mobile)
        this.removeEventListener = function (type, callback) {
            if (this.windowRef) {
                if (type === 'loadstart' || type === 'loadstop' ||
                    type === 'loaderror' || type === 'exit') {
                    this.windowRef.removeEventListener(type, function (event) {
                        if (callback) {
                            callback(event);
                        }
                    });
                } else {
                    console.log('WARNING: InAppBrowser does not support event type - ' + type);
                }
            }
        }.bind(this);

        // Close the browser
        this.close = function () {
            this.windowRef.close();
        };
    };

    // Return Constructor
    return Browser.prototype.constructor;
});

